import { render, staticRenderFns } from "./newInfo.vue?vue&type=template&id=44c2dd6a&scoped=true&"
import script from "./newInfo.vue?vue&type=script&lang=js&"
export * from "./newInfo.vue?vue&type=script&lang=js&"
import style0 from "./newInfo.vue?vue&type=style&index=0&id=44c2dd6a&lang=scss&scoped=true&"
import style1 from "./newInfo.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c2dd6a",
  null
  
)

export default component.exports